// Cancel-account boundary. STUB: there is no backend yet, so nothing here
// touches the network or the real account. Replace `cancelAccount` with
// DELETE /v1/users/me (through the waggle-app proxy) when the API ticket lands.

export type CancelReason = "too_expensive" | "not_using" | "missing_features" | "switching" | "other";

export interface CancelAccountInput {
  reason?: CancelReason;
  details?: string;
}

export const CANCEL_REASONS: { id: CancelReason; label: string }[] = [
  { id: "too_expensive", label: "Too expensive" },
  { id: "not_using", label: "I'm not using it" },
  { id: "missing_features", label: "Missing features I need" },
  { id: "switching", label: "Switching to another tool" },
  { id: "other", label: "Other" },
];

export const CANCEL_DETAILS_MAX = 500;

// Dev/e2e hook so the failure path can be exercised. Remove with the stub.
export const STUB_FAIL_KEY = "waggle_stub_cancel_fail";

export async function cancelAccount(_input: CancelAccountInput): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 800));
  let fail = false;
  try {
    fail = localStorage.getItem(STUB_FAIL_KEY) === "1";
  } catch {
    // storage unavailable: behave as success
  }
  if (fail) throw new Error("We couldn't cancel your account. Please try again.");
}

export function emailMatches(typed: string, email: string): boolean {
  const t = typed.trim().toLowerCase();
  return t.length > 0 && t === email.trim().toLowerCase();
}
